import { ref } from 'vue';
import PostSaleCasesAPI from 'dashboard/api/postSaleCases';

const COMPLETE_DATE = /^\d{2}\/\d{2}\/\d{4}$/;

const normalizeHour = item => ({
  hora: String(item?.hora || '').trim(),
  permisao: [true, 1, '1'].includes(item?.permisao),
});

export function usePostSaleDeedAvailability() {
  const hours = ref([]);
  const loading = ref(false);
  const error = ref('');
  let requestSequence = 0;

  const clear = () => {
    requestSequence += 1;
    hours.value = [];
    loading.value = false;
    error.value = '';
  };

  const load = async (postSaleCaseId, date) => {
    requestSequence += 1;
    const sequence = requestSequence;
    if (!postSaleCaseId || !COMPLETE_DATE.test(String(date || ''))) {
      hours.value = [];
      loading.value = false;
      error.value = '';
      return [];
    }

    hours.value = [];
    loading.value = true;
    error.value = '';
    try {
      const { data } = await PostSaleCasesAPI.deedAvailability(postSaleCaseId, {
        date,
      });
      if (sequence !== requestSequence) return [];

      hours.value = (data?.hora_permisao_real || [])
        .map(normalizeHour)
        .filter(item => item.hora);
      return hours.value;
    } catch (requestError) {
      if (sequence === requestSequence) {
        hours.value = [];
        error.value = requestError;
      }
      return [];
    } finally {
      if (sequence === requestSequence) loading.value = false;
    }
  };

  return { clear, error, hours, load, loading };
}
